/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  Component,
  OnInit
}                                from '@angular/core';

import { Logger                } from '../../util/logger';

@Component({
  templateUrl: 'profile.page.component.html'
})

/**
 *
 * @class ProfilePageComponent
 *
 * @brief "my account" page for users
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class ProfilePageComponent implements OnInit {

  /** standard constructor */
  constructor(
  ) {

  }

  /** on page setup, create the form validator */
  ngOnInit() {

    Logger.debug('[ProfilePage] init...');



  }

}
